
import React, { useEffect, useState } from "react";
import { Modal, Spin, message } from "antd";
import styled from "styled-components";
import { CloseOutlined } from "@ant-design/icons";
import api from "../../../api/api";
import { useTranslation } from "react-i18next";

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 20px;
    padding: 20px;
    display:flex;
    justify-content: center;
    align-items:center;
  }

  .ant-modal-header,
  .ant-modal-footer {
    display: none;
  }

  .ant-modal-close {
    display: flex;
    align-items: center;
    justify-content: center;
    top: 12px;
    right: 12px;
    color: #9aa1b2;
  }

  .ant-modal-body {
    padding: 0;
  }
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderTitle = styled.h3`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #1a1d29;
`;
 const QRContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding 40px 0px;
`;

const QRImage = styled.img`
  width: 320px;
  height: 320px;
  max-width: 100%;
  object-fit: contain;
  display: block;
`;

const LoadingWrap = styled.div`
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EmptyQR = styled.div`
  width: 320px;
  height: 320px;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #9aa1b2;
  font-size: 14px;
`;

const ViewQRReceiptModal = ({
  open,
  handleClose,
  orderId,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [qrImage, setQrImage] = useState(null);

  useEffect(() => {
    if (!open || !orderId) {
      return;
    }

    const generateQR = async () => {
      setLoading(true);
      setQrImage(null);

      try {
        const response = await api.generateQRScan({
          order_id: orderId,
        });

        const image = response?.data?.order_qr || null;

        if (!image) {
          message.error(t("qr_not_available"));
          return;
        }

        setQrImage(image);
      } catch (error) {
        console.error("Generate QR error:", error);

        message.error(
          error?.response?.data?.message ||
            error?.message ||
            t("failed_load_qr")
        );
      } finally {
        setLoading(false);
      }
    };

    generateQR();
  }, [open, orderId, t]);

  return (
    <StyledModal
      centered
      open={open}
      onCancel={handleClose}
      width={400}
      footer={null}
      destroyOnClose
      closable
      closeIcon={<CloseOutlined style={{ fontSize: 18 }} />}
    >
      <Header> 
        <HeaderTitle> 
          {t("qr_receipt")} 
        </HeaderTitle>
      </Header>
      {loading ? (
        <LoadingWrap>
          <Spin size="large" />
        </LoadingWrap>
      ) : qrImage ? (
        <QRContainer>
          <QRImage
            src={qrImage}
            alt="Order QR Code"
          />
        </QRContainer>
      ) : (
        <EmptyQR>
          {t("qr_not_available")}
        </EmptyQR>
      )}
    </StyledModal>
  );
};

export default ViewQRReceiptModal;
